import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Donation from "./Donation";
import "./Navbar.css";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function Navbar() {
	const mobile = useMediaQuery("(max-width: 480px)");

	const [donateDialog, setDonateDialog] = useState(false);

	return (
		<header>
			<nav>
				<Link to={useLocation().pathname === "/about" ? "/" : "/about"}>
					{useLocation().pathname === "/about" ? "Home" : "About"}
				</Link>
				<a href="mailto:info@railforless.us">Contact</a>
				<a onClick={() => setDonateDialog(true)}>Donate</a>
				<Link to={useLocation().pathname === "/alerts" ? "/" : "/alerts"}>
					{useLocation().pathname === "/alerts"
						? "Home"
						: `${!mobile ? "Fare " : ""}Alerts`}
				</Link>
				<a
					href="https://discord.gg/4sCWj8Jy9m"
					rel="noopener noreferrer"
					target="_blank"
				>
					<SvgIcon viewBox="0 0 24 24">
						<path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057.1 18.082.114 18.106.135 18.12a19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
					</SvgIcon>
				</a>
			</nav>
			<Dialog
				id="donate-dialog"
				onClose={() => setDonateDialog(false)}
				open={donateDialog}
			>
				<DialogContent sx={{ minWidth: "20rem !important" }}>
					<IconButton aria-label="close" onClick={() => setDonateDialog(false)}>
						<CloseIcon />
					</IconButton>
					<Donation />
				</DialogContent>
			</Dialog>
		</header>
	);
}
